import React from "react";

const CounterAreaThreeItem = ({ item }) => {
  return (
    <div className="counter-item-three">
      <div className="icon">
        <img src={item.src} alt="" />
      </div>
      <div className="content">
        <h2 className="count">{item.amount}+</h2>
        <p>
          {item.titles[0]} <span>{item.titles[1]}</span>
        </p>
      </div>
    </div>
  );
};

export default CounterAreaThreeItem;
